var ContentType;
(function (ContentType) {
    ContentType["HEADER"] = "header";
    ContentType["BANNER"] = "banner";
    ContentType["FOOTER"] = "footer";
    ContentType["LEFT"] = "left";
    ContentType["INLINE"] = "inline";
})(ContentType || (ContentType = {}));
export class MerchandisingStore {
    constructor(services, merchData) {
        this.redirect = '';
        this.content = {};
        if (merchData) {
            this.redirect = merchData.redirect || '';
            if (merchData.content) {
                Object.values(ContentType).forEach((type) => {
                    if (merchData.content && merchData.content[type]) {
                        this.content[type] = new Content(merchData.content[type]);
                    }
                });
            }
        }
    }
}
class Content extends Array {
    static get [Symbol.species]() {
        return Array;
    }
    constructor(content) {
        super(...content);
    }
}
